
import { Vue, Component } from "vue-property-decorator";
import router from "@/router";

@Component({})
export default class BadFit extends Vue {
  public created(): void {
    window.scrollTo(0, 0);
  }
}
